// src/components/MessageInfoDialog.js

import React from 'react';
// 'Divider' has been removed from this import line
import { Dialog, DialogTitle, DialogContent, Typography, DialogActions, Button, Box } from '@mui/material';
import { format } from 'date-fns';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DoneAllIcon from '@mui/icons-material/DoneAll';

const InfoRow = ({ label, time, icon }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
    {icon}
    <Box sx={{ ml: 2 }}>
      <Typography variant="body1">{label}</Typography>
      <Typography variant="body2" color="text.secondary">
        {time ? format(time.toDate(), 'PPP p') : '...'}
      </Typography>
    </Box>
  </Box>
);

const MessageInfoDialog = ({ open, onClose, message }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Message Info</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" component="div" sx={{ p: 2, backgroundColor: 'background.paper', borderRadius: 1, mb: 2 }}>
          {message?.text || (message?.type === 'voice' ? "Voice Message" : "...")}
        </Typography>
        <InfoRow label="Sent" time={message?.createdAt} icon={<CheckCircleIcon color="disabled" />} />
        <InfoRow label="Delivered" time={message?.deliveredAt} icon={<CheckCircleIcon color={message?.deliveredAt ? 'primary' : 'disabled'} />} />
        <InfoRow label="Read" time={message?.readAt} icon={<DoneAllIcon color={message?.readAt ? 'primary' : 'disabled'} />} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default MessageInfoDialog;